import { render, staticRenderFns } from "./remCom.vue?vue&type=template&id=6fc8e94f&scoped=true"
import script from "./remCom.vue?vue&type=script&lang=js"
export * from "./remCom.vue?vue&type=script&lang=js"
import style0 from "../assets/css/rem.css?vue&type=style&index=0&id=6fc8e94f&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc8e94f",
  null
  
)

export default component.exports